import { Controller } from "@hotwired/stimulus"


// Connects to data-controller="video-stopper"
export default class extends Controller {
  connect() {
    this.handleClick = this.handleClick.bind(this);
    
    // Remove any existing identical event listeners before adding a new one
    document.removeEventListener('click', this.handleClick, true);    
    document.addEventListener('click', this.handleClick, true);
  }

  disconnect() {
    document.removeEventListener('click', this.handleClick, true);
  }

  handleClick(event) {
    const link = event.target.closest('a');

    if (link && link.href && !link.hasAttribute('data-turbo-method') && link.target !== '_blank') {
      event.preventDefault();
      const videos = document.querySelectorAll('video');
      videos.forEach(video => {
        video.muted = true;
        video.pause();
        const sources = video.querySelectorAll('source');
        sources.forEach(source => source.remove());
        video.load();
      });
      window.Turbo.visit(link.href);
    }
  }
}